module.exports = __webpack_public_path__ + "img/LTC-ability-04.7efd49db.png";